document.addEventListener("DOMContentLoaded", function () {
  const botonContacto = document.querySelector(".formulario_showroom");
  if (botonContacto) {
    botonContacto.addEventListener("click", showContactoModal);
  }

  function showContactoModal() {
    document.documentElement.classList.add("remove-scrolling");

    const modalHTML = `
    <div class="formulario-contacto-dulox-modal-overlay visible" id="contactoModalOverlay">
      <div class="formulario-contacto-dulox-modal">
        <button class="formulario-contacto-dulox-cerrar" aria-label="Cerrar">×</button>
        <h2 class="formulario-contacto-dulox-titulo">Agendar Visita Showroom</h2>
        <p class="formulario-contacto-dulox-subtitulo">
          Completa el formulario para agendar una visita a nuestra empresa
        </p>
        
        <form id="formularioContactoDulox" class="formulario-contacto-dulox-form">
          <div class="formulario-contacto-dulox-campo-group">
            <div class="formulario-contacto-dulox-campo">
              <label for="contactoNombre">Nombre Completo*</label>
              <input type="text" id="contactoNombre" name="nombre" required minlength="4" maxlength="100" placeholder="Ej: Juan Pérez">
            </div>
          </div>

          <div class="formulario-contacto-dulox-campo-group">
            <div class="formulario-contacto-dulox-campo">
              <label for="contactoCorreo">Correo Electrónico*</label>
              <input type="email" id="contactoCorreo" name="email" minlength="6" maxlength="100" required placeholder="Ej: juan@email.com">
            </div>
            <div class="formulario-contacto-dulox-campo">
              <label for="contactoTelefono">Teléfono*</label>
              <input type="tel" id="contactoTelefono" name="telefono" minlength="8" maxlength="14" required placeholder="Ej: +56912345678">
            </div>
          </div>

          <div class="formulario-contacto-dulox-campo">
            <label>Preferencia de contacto*</label>
            <div class="formulario-contacto-dulox-checkbox-group">
              <label class="checkbox-container">
                <input type="checkbox" name="contacto_por[]" value="correo">
                <span class="checkmark"></span>
                Correo Electrónico
              </label>
              <label class="checkbox-container">
                <input type="checkbox" name="contacto_por[]" value="telefono">
                <span class="checkmark"></span>
                Llamada Telefónica
              </label>
            </div>
          </div>

          <div class="formulario-contacto-dulox-campo">
            <label for="contactoFechaHora">Fecha y hora preferente*</label>
            <input type="text" id="contactoFechaHora" name="fecha_hora" required placeholder="Selecciona fecha y hora" readonly>
          </div>

          <div class="formulario-contacto-dulox-campo">
          <div class="g-recaptcha" data-sitekey="6Ld1vVArAAAAAEt-hzqqtIqKm1bDEw-gPzQnyBn-"></div>
          </div>

          <div class="formulario-contacto-dulox-botones">
            <button type="button" class="formulario-contacto-dulox-cancelar">Cancelar</button>
            <button type="submit" class="formulario-contacto-dulox-boton">
              Enviar Solicitud
            </button>
          </div>
        </form>
      </div>
    </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);

    // Flatpickr
    flatpickr("#contactoFechaHora", {
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      time_24hr: true,
      minTime: "09:00",
      maxTime: "13:00",
      disable: [
        function (date) {
          return date.getDay() === 0 || date.getDay() === 6;
        },
      ],
      locale: {
        firstDayOfWeek: 1,
      },
    });

    // reCaptcha
    setTimeout(() => {
      // Ensure the reCAPTCHA API has loaded before trying to render
      if (typeof grecaptcha !== "undefined") {
        grecaptcha.render(document.querySelector(".g-recaptcha"), {
          sitekey: "6Ld1vVArAAAAAEt-hzqqtIqKm1bDEw-gPzQnyBn-",
        });
      } else {
        console.error("reCAPTCHA API not loaded!");
        // Optionally, you could try to reload the script here if needed
      }
    }, 100);

    const overlay = document.getElementById("contactoModalOverlay");
    const closeBtn = document.querySelector(
      ".formulario-contacto-dulox-cerrar"
    );
    const cancelBtn = document.querySelector(
      ".formulario-contacto-dulox-cancelar"
    );

    function closeModal() {
      overlay.classList.remove("visible");
      document.documentElement.classList.remove("remove-scrolling");
      if (typeof grecaptcha !== "undefined") {
        grecaptcha.reset();
      }
      setTimeout(() => overlay.remove(), 300);
    }

    closeBtn?.addEventListener("click", closeModal);
    cancelBtn?.addEventListener("click", closeModal);

    const telefonoInput = document.getElementById("contactoTelefono"); // Asegúrate de que el ID del campo de teléfono sea 'telefono'.

    telefonoInput.addEventListener("input", function () {
      // Elimina cualquier espacio y deja solo números
      this.value = this.value.replace(/\D/g, ""); // Reemplaza todo lo que no sea número
    });

    const form = document.getElementById("formularioContactoDulox");
    const submitBtn = form.querySelector("button[type='submit']");

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // Validaciones personalizadas
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const telefonoRegex = /^\d{8,14}$/;

      const nombre = form.querySelector("#contactoNombre").value.trim();
      const email = form.querySelector("#contactoCorreo").value.trim();
      const telefono = form
        .querySelector("#contactoTelefono")
        .value.replace(/\D/g, "");
      const fechaHora = form.querySelector("#contactoFechaHora").value;

      if (nombre.length < 4 || nombre.length > 100) {
        alert("El nombre debe tener entre 4 y 100 caracteres.");
        return;
      }

      // Validaciones
      if (!emailRegex.test(email)) {
        alert("Por favor ingresa un correo electrónico válido.");
        return;
      }

      if (!telefonoRegex.test(telefono)) {
        alert(
          "El teléfono debe contener solo números y tener entre 8 y 14 dígitos."
        );
        return;
      }

      // Validación checkboxes
      const checkboxes = form.querySelectorAll(
        'input[name="contacto_por[]"]:checked'
      );
      if (checkboxes.length === 0) {
        alert("Seleccione al menos un método de contacto");
        return;
      }

      // Verificar si el usuario ingresó una fecha
      if (!fechaHora) {
        alert("Por favor, seleccione una fecha y hora.");
        return;
      }

      // Formatear a ISO 8601 (con 'T') para evitar Invalid Date
      const fechaValida = fechaHora.replace(" ", "T");
      const fecha = new Date(fechaValida);

      // Verificar que la fecha sea válida
      if (isNaN(fecha.getTime())) {
        alert("La fecha y hora seleccionadas no son válidas.");
        return;
      }

      // Obtener hora y día
      const hora = fecha.getHours();
      const diaSemana = fecha.getDay();

      // Validar día hábil (lunes a viernes)
      if (diaSemana === 0 || diaSemana === 6) {
        alert("Seleccione un día hábil (Lunes a Viernes).");
        return;
      }

      // Validar rango horario
      if (hora < 9 || hora >= 13) {
        alert("El horario debe ser entre 09:00 y 13:00 hrs.");
        return;
      }

      // Validación reCaptcha google
      const recaptchaResponse = grecaptcha.getResponse();
      if (!recaptchaResponse) {
        alert("Por favor completa el verificador de seguridad");
        return;
      }

      // Desactivar botón y mostrar carga
      const originalText = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <svg class="loading-icon" style="margin: 0 auto; width: 20px; height: 20px;" width="24" height="24" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
          <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
            <path d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" opacity=".2"/>
            <path d="M7.25.75A.75.75 0 0 1 8 0a8 8 0 0 1 8 8 .75.75 0 0 1-1.5 0A6.5 6.5 0 0 0 8 1.5a.75.75 0 0 1-.75-.75"/>
          </g>
        </svg>
      `;

      try {
        const formData = new FormData(form);
        formData.append("g-recaptcha-response", recaptchaResponse);

        const response = await fetch(
          "https://paleturquoise-curlew-987337.hostingersite.com/DuloxAPI/showroom_dulox.php",
          {
            method: "POST",
            body: formData,
          }
        );

        const result = await response.json();

        if (result.success) {
          closeModal();
          mostrarExito();
        } else {
          alert(result.error || "Error al enviar");
          if (typeof grecaptcha !== "undefined") {
            grecaptcha.reset();
          }
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Error de conexión");
      } finally {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });

    function mostrarExito() {
      const modalExito = document.createElement("div");
      modalExito.className = "formulario-contacto-dulox-modal-overlay visible";
      modalExito.innerHTML = `
        <div class="formulario-contacto-dulox-modal mensaje-final">
          <h2 class="formulario-contacto-dulox-titulo">¡Visita agendada!</h2>
          <p class="mensaje-final">Hemos recibido tu solicitud y nos pondremos en contacto contigo para confirmar.</p>
          <button class="formulario-contacto-dulox-boton" onclick="this.closest('.formulario-contacto-dulox-modal-overlay').remove(); document.documentElement.classList.remove('remove-scrolling')">Cerrar</button>
        </div>
      `;
      document.body.appendChild(modalExito);
    }
  }
});
